<template>
    <div>
        <el-form :inline="true">
            <el-form-item>
                <el-input v-model="queryCondition.userId" placeholder="请输入用户账户"/>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="queryRecord(1)">搜索</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="recordList">
            <el-table-column label="抢红包账户" prop="receiveUserId"/>
            <el-table-column label="是否注册" prop=""/>
            <el-table-column label="微信昵称" prop=""/>
            <el-table-column label="openID" prop=""/>
            <el-table-column label="红包币种" prop="coinType"/>
            <el-table-column label="红包金额" prop="volume"/>
            <el-table-column label="领取状态">
                <template slot-scope="scope">
                    {{scope.row.status === 1 ? '待领取' : scope.row.status === 2 ? '已领取' : scope.row.status === 3 ? '过期' : '--'}}
                </template>
            </el-table-column>
            <el-table-column label="抢红包时间">
                <template slot-scope="scope">
                    {{scope.row.createTime | moment}}
                </template>
            </el-table-column>
            <el-table-column label="领取时间">
                <template slot-scope="scope">
                    {{scope.row.receiveTime | moment}}
                </template>
            </el-table-column>
        </el-table>

        <el-pagination background layout="prev, pager, next" :total="total" :page-size="10"
                       :current-page="queryCondition.page" @current-change="queryRecord"/>

    </div>
</template>

<script>
    import api from './api';

    export default {
        name: "getRecord",
        data() {
            return {
                queryCondition: {
                    userId: '',
                    page: 1,
                },
                recordList: [],
                total: 0,
            }
        },
        created() {
            if (this.$route.params.redEnvelopeId) {
                this.queryCondition.id = this.$route.params.redEnvelopeId;
            }
            this.queryRecord(1);
        },
        methods: {
            queryRecord(val) {
                this.queryCondition.page = val;
                api.receiveList(this.queryCondition).then(response => {
                    this.recordList = response.data.list;
                    this.total = response.data.total;
                })
            }
        },
    }
</script>

<style scoped>

</style>
